import { QueryClient } from 'react-query';
import { queryKey } from 'constants/queryKey';
import type {
  TranslationFields,
  TranslationJobResponse,
} from 'types/AiHubTranslation';
import type { PostDetail } from 'types/PostDetail';

export function optimisticallySetTranslationJobProcessing(
  queryClient: QueryClient,
  postId: number,
  targetLanguage: string,
) {
  queryClient.setQueryData<TranslationJobResponse | undefined>(
    queryKey.postTranslation(postId),
    (old) => ({
      ...old,
      status: 'processing' as const,
      targetLanguage,
    }),
  );
}

export function optimisticallyApplyTranslation(
  queryClient: QueryClient,
  postId: number,
  fields: TranslationFields,
) {
  queryClient.setQueryData<PostDetail | undefined>(
    queryKey.postDetail(postId),
    (old) => {
      if (!old) return old;

      const updated = { ...old };

      if (fields.postText?.translated) {
        updated.text = fields.postText.translated;
      }

      if (
        fields.firstComment?.translated &&
        updated.attachments?.firstComment
      ) {
        updated.attachments = {
          ...updated.attachments,
          firstComment: {
            ...updated.attachments.firstComment,
            text: fields.firstComment.translated,
          },
        };
      }

      return updated;
    },
  );
}
